import { AngleUnit, formatAngle, IFormattingSettings } from '@fulcrum/lib';
import * as Converter from '../unit-of-measure/angle-converter';
import { t } from '@trimble/i18n';
import { BaseFormatterProps } from './base-formatter-props.types';
import { AngleMeasurement } from '@trimble/types';

/**
 * The conversion is achieved by first converting to degrees (deg) as an intermediate step.
 * The 'fulcrum' library uses degrees as its base unit for angles.
 *
 * @remarks Trimble APIs typically use degrees for angle measurements.
 */
export const toDisplay = ({
  measuredValue,
  currentUnits,
  settings,
}: BaseFormatterProps<
  AngleMeasurement,
  AngleUnit,
  IFormattingSettings
>): string => {
  let measuredValueInDegrees;
  if (currentUnits !== 'deg') {
    // Convert to deg first due to fulcrum lib using deg as base unit
    measuredValueInDegrees = Converter.mapToDegrees({
      value: measuredValue,
      baseUnit: currentUnits,
    });
  } else if (typeof measuredValue === 'number') {
    measuredValueInDegrees = measuredValue;
  } else {
    throw new Error('Provided value does not match indicated unit');
  }

  if (measuredValueInDegrees !== null) {
    return formatAngle(
      measuredValueInDegrees,
      settings.angleUnit ?? 'deg',
      settings.angleDecimals
    );
  } else {
    return t('Utilities.Formatting.InvalidUnit', {
      defaultValue: 'Invalid Unit',
    });
  }
};
